export default __webpack_public_path__ + "static/media/05.b4f8e874.jpg";